import { Injectable } from '@angular/core';

@Injectable()
export class DetectPlatformService {
  public getPlatform(): 'ios' | 'android' | null {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'ios';
    } else if (/android/i.test(userAgent)) {
      return 'android';
    } else {
      return null;
    }
  }
  public getPlatformV2(): 'ios' | 'android' | 'macos' | null {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'ios';
    } else if (/android/i.test(userAgent)) {
      return 'android';
    } else if (/Macintosh/i.test(userAgent)) {
      return 'macos';
    } else {
      return null;
    }
  }
  public get isMobilePlatform(): boolean {
    return this.getPlatform() === 'ios' || this.getPlatform() === 'android';
  }
}
